import axios from "@/utils/axiosHelper";

// 根据rid获取用户所需要的accesstoken
export const onGetToken = params => {
    return axios(
        { url: "/sea/login", method: "post", params },
        { interceptResultCode: false }
    );
};

// 初始化用户数据
export const onGetUserInfo = params => {
    return axios(
        { url: "/sea/tw/five/init", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 签到领取奖励
export const onGetReward = params => {
    return axios(
        { url: "/sea/tw/five/store", method: "post", params },
        { interceptResultCode: false }
    );
};




// WEBPACK FOOTER //
// ./src/pages/snail/snail_5thSpecial/api.js